import { Injectable } from '@angular/core';

const TRANSLATIONS = {
  400001: 'La fecha de ingreso es obligatoria',
  400002: 'La fecha de salida es obligatoria',
  400003: 'Existe un error en la URL',
  400004: 'El formato de la fecha de ingreso es inválido',
  400005: 'El formato de la fecha de salida es inválido',
  400006: 'El tiempo de estadía debe ser menor a las 27 noches. Por favor intentá una nueva búsqueda',
  400007: 'La fecha de ingreso debe ser anterior a la fecha de salida. Por favor intentá una nueva búsqueda',
  400008: 'La fecha de ingreso es igual a la fecha de salida. Por favor intentá una nueva búsqueda',
  400009: 'La fecha de ingreso debe ser, como mínimo, 2 días posterior al día de hoy. Por favor intentá una nueva búsqueda',
  400010: 'Existe un error en la URL',
  400011: 'El Site es obligatorio',
  400012: 'Existe un error en la URL',
  400013: 'Existe un error en la URL',
  400014: 'El ID del hotel no existe',
  400016: 'La fecha de ingreso es menor al día de hoy. Por favor intentá una nueva búsqueda',
};

@Injectable()
export class TranslateService {
  constructor() {}

  public translate(code, defaultMessage) {
    return TRANSLATIONS[code] ? TRANSLATIONS[code] : defaultMessage;
  }
}
